import React from "react";
import CourseworkLayout from "./coursework_layout";

const CourseworkPage = () => {
  return <CourseworkLayout />;
};

export default CourseworkPage;